module.exports = __webpack_public_path__ + "img/89823918003240.86860f91.png";